import { useEffect, useRef, useState } from "react"

export const useInViewport = (options = {}) => {
  const [isInViewport, setIsInViewport] = useState(false)
  const ref = useRef<HTMLDivElement | null>(null)

  useEffect(() => {
    const refValue = ref.current
    const observer = new IntersectionObserver(([entry]) => {
      if (!isInViewport) {
        setIsInViewport(entry.isIntersecting)
      }
    }, options)

    if (refValue && !isInViewport) {
      observer.observe(refValue)
    }

    return () => {
      if (refValue) {
        observer.unobserve(refValue)
      }
    }
  }, [ref, options, isInViewport])

  return [ref, isInViewport] as const
}
